module.exports = __webpack_public_path__ + "static/2017-books-9cded14df2794297336513fffe2852d5.jpg";